import { graphql } from '@/graphql-setup'

export const ALL_TIME_ADDONS = graphql(`
  query AllTimeAddons($dateStart: DateTime, $dateEnd: DateTime, $user: ID) {
    allTimeAddons(dateStart: $dateStart, dateEnd: $dateEnd, user: $user) {
      edges {
        node {
          id
          datetimeStart
          datetimeEnd
          overrideOtherAddons
          salaryCode {
            id
            name
            externalId
          }
          salaryCodeIfOvertime {
            id
            name
            externalId
          }
          comment
        }
      }
    }
  }
`)

export const ALL_FIXED_HOURLY_ADDONS = graphql(`
  query AllFixedHourlyAddons($user: ID, $salaryWorkTime: ID) {
    allFixedHourlyAddons(user: $user, salaryWorkTime: $salaryWorkTime) {
      edges {
        node {
          id
          salaryCode {
            id
            name
            externalId
          }
          salaryCodeIfOvertime {
            id
            name
            externalId
          }
          validFrom
          validTo
        }
      }
    }
  }
`)

export const ALL_FIXED_SALARY_ADDONS = graphql(`
  query AllFixedSalaryAddons($user: ID, $salaryWorkTime: ID) {
    allFixedSalaryAddons(user: $user, salaryWorkTime: $salaryWorkTime) {
      edges {
        node {
          id
          salaryCode {
            id
            name
            externalId
          }
          validFrom
          validTo
        }
      }
    }
  }
`)

export const ALL_FIXED_SALARY_DAY_ADDONS = graphql(`
  query AllFixedSalaryDayAddons($user: ID, $salaryWorkTime: ID) {
    allFixedSalaryDayAddons(user: $user, salaryWorkTime: $salaryWorkTime) {
      edges {
        node {
          id
          salaryCode {
            id
            name
            externalId
          }
          validFrom
          validTo
        }
      }
    }
  }
`)

export const ALL_TIME_OVERRIDES = graphql(`
  query AllTimeOverrides($dateStart: DateTime, $dateEnd: DateTime, $user: ID) {
    allTimeOverrides(dateStart: $dateStart, dateEnd: $dateEnd, user: $user) {
      edges {
        node {
          id
          datetimeStart
          datetimeEnd
          salaryCode {
            id
            name
            externalId
          }
          comment
        }
      }
    }
  }
`)

export const SALARY_BASES = graphql(`
  query SalaryBases {
    allSalaryBases {
      id
      name
      year
      month
      createdAt
      missingExports
    }
  }
`)

export const SALARY_BASE = graphql(`
  query SalaryBase($id: ID!) {
    salaryBase(id: $id) {
      id
      name
      year
      month
      datetimeStart
      datetimeEnd
      createdAt
    }
  }
`)

export const SALARY_BASE_ENTRIES = graphql(`
  query SalaryBaseEntries(
    $id: ID!
    $user: ID
    $leaderGroups: [String!]
    $onlyNonExported: Boolean
    $orderBy: String
  ) {
    allSalaryBaseEntries(
      salaryBase: $id
      user: $user
      leaderGroups: $leaderGroups
      onlyNonExported: $onlyNonExported
      orderBy: $orderBy
    ) {
      edges {
        node {
          id
          user {
            id
            fullName
            internalNumber
          }
          initialAmount
          amount
          departmentId
          facilityId
          salaryId
          exportTimestamp
        }
      }
    }
  }
`)

export const ALL_FIXED_ADDONS = graphql(`
  query AllFixedAddons($dateStart: DateTime, $dateEnd: DateTime, $userId: ID) {
    allFixedAddons(user: $userId, dateStart: $dateStart, dateEnd: $dateEnd) {
      edges {
        node {
          id
          date
          amount
          salaryCode {
            id
            name
            externalId
          }
          comment
        }
      }
    }
  }
`)

export const SALARY_STATISTICS = graphql(`
  query SalaryStatistics($year: Int!, $month: Int!) {
    allUsersWithExportedSalaryBaseEntries(year: $year, month: $month) {
      id
      fullName
    }
    allUsersWithUnexportedSalaryBaseEntries(year: $year, month: $month) {
      id
      fullName
    }
    allUsersMissingSalaryBaseEntries(year: $year, month: $month) {
      id
      fullName
    }
  }
`)

export const WORK_PERIOD_MONTH_REPORT = graphql(`
  query WorkPeriodMonthReport(
    $user: ID!
    $datetimeStart: DateTime!
    $datetimeEnd: DateTime!
    $year: Int!
    $month: Int!
  ) {
    monthReport(
      user: $user
      datetimeStart: $datetimeStart
      datetimeEnd: $datetimeEnd
    ) {
      totalWorkTime
      isLocked
      workPeriodGroups {
        id
        approvedByManager
        approvedByUser
        absenceDay {
          date
          absence {
            id
            reason
            absenceType {
              id
              name
              externalId
            }
          }
        }
        workPeriods {
          id
          datetimeStart
          datetimeEnd
          approvedByUser
          userComment
          approvedByManager
          managerComment

          driverDiet {
            __typename
            id
            partOfDay
            comment
            salaryCode {
              id
              name
              externalId
            }
            isManuallyEdited
          }
          salaryDay {
            __typename
            id
            partOfDay
            salaryCode {
              id
              name
              externalId
            }
            isManuallyEdited
          }
          user {
            id
            fullName
          }
          groupedActivitySums {
            name
            id
            salaryId
            sum
          }
          groupedActivities {
            salaryId
            salaryName

            vehicleVin
            regNr
            startTime
            endTime
          }
          activities {
            id
            activityType
            datetimeStart
            datetimeEnd
            excludeFromSalaryCalculation
            excludeBefore
            excludeAfter
            duration
          }
          salaryActivities {
            id
            activityType
            datetimeStart
            datetimeEnd
            excludeFromSalaryCalculation
            excludeBefore
            excludeAfter
            duration
          }
          timeEntries {
            id
            datetimeStart
            datetimeEnd
            totalWorkTime
            comment
          }
          salarySetting {
            id
            salaryType
          }
        }
        totalWorkTime
        overtime
        paidPause
        requiredPause
        calendarItem {
          __typename
          id
          title
          start
          end
          duration
          vehicle {
            registrationNumber
            department {
              id
              name
              externalId
            }
            facility {
              id
              name
              externalId
            }
          }
          secondaryVehicle {
            registrationNumber
          }
        }
        groupedActivitySums {
          name
          id
          sum
          negative
          salaryId
        }
        groupedActivitySumsFloat {
          name
          id
          salaryId
          sum
        }
      }
      overtime {
        name
        id
        sum
        nextMonth
      }
      undertime {
        name
        id
        sum
        nextMonth
      }
      groupedActivitySums {
        name
        id
        sum
        salaryId
      }
      groupedActivitySumsFloat {
        name
        id
        sum
        salaryId
      }
      salaryCorrections {
        id
        reason
        amount
        salaryCode {
          id
          name
          externalId
        }
        department {
          id
          name
          externalId
        }
        facility {
          id
          name
          externalId
        }
        createdAt
        createdBy {
          id
          fullName
        }
      }
    }
    allSalaryComments(user: $user, year: $year, month: $month) {
      id
      value
      createdBy {
        id
        fullName
      }
      createdAt
    }
    salaryBaseByMonth(year: $year, month: $month) {
      id
      name
      year
      month
      createdAt
      entriesWithoutDepartment(userId: $user) {
        id
        user {
          id
          fullName
          internalNumber
        }
        initialAmount
        amount
        departmentId
        salaryId
      }
    }
  }
`)

export const ALL_SALARY_CORRECTIONS_QUERY = graphql(`
  query SalaryCorrectionComboboxQuery {
    allSalaryCorrections {
      id
      user {
        id
        fullName
      }
      reason
      department {
        id
        name
        externalId
      }
      facility {
        id
        name
        externalId
      }
      salaryCode {
        id
        name
        externalId
      }
      amount
      createdAt
    }
  }
`)

export const WORK_PERIODS = graphql(`
  query AllWorkPeriods(
    $user: ID
    $datetimeStart: DateTime!
    $datetimeEnd: DateTime!
  ) {
    allWorkPeriods(
      user: $user
      datetimeStart: $datetimeStart
      datetimeEnd: $datetimeEnd
    ) {
      edges {
        node {
          id
          datetimeStart
          datetimeEnd
          approvedByUser
          approvedByManager
          userComment
          managerComment
          user {
            id
            fullName
          }
          hasTimeEntries
          driverDiet {
            __typename
            id
            partOfDay
            comment
            salaryCode {
              id
              name
              externalId
            }
            isManuallyEdited
          }
          salaryDay {
            __typename
            id
            partOfDay
            salaryCode {
              id
              name
              externalId
            }
            isManuallyEdited
          }
          calendarItem {
            __typename
            id
            title
            start
            end
          }
          addonsAsText
          salarySetting {
            id
            name
            salaryType
          }
          absenceHourTransaction {
            id
          }
        }
      }
    }
    remainingWorkPeriodResolving(
      datetimeStart: $datetimeStart
      datetimeEnd: $datetimeEnd
    ) {
      user {
        id
        fullName
      }
      numTasks
    }
  }
`)

export const WORK_PERIODS_START_STOP_COUNTRY = graphql(`
  query AllWorkPeriodsStartStopCountry(
    $user: ID
    $datetimeStart: DateTime!
    $datetimeEnd: DateTime!
  ) {
    allWorkPeriods(
      user: $user
      datetimeStart: $datetimeStart
      datetimeEnd: $datetimeEnd
    ) {
      edges {
        node {
          id
          datetimeStart
          datetimeEnd
          user {
            id
            fullName
          }
          startCountry {
            id
            country
          }
          stopCountry {
            id
            country
          }
        }
      }
    }
  }
`)

export const WORK_PERIOD = graphql(`
  query WorkPeriod($id: ID!) {
    workPeriod(id: $id) {
      id
      datetimeStart
      datetimeEnd
      approvedByUser
      approvedByManager
      userComment
      managerComment
      absenceHourTransaction {
        id
      }
      user {
        id
        fullName
      }
      activities {
        id
        vehicleRegistrationNumber
        activityType
        datetimeStart
        datetimeEnd
      }
      activityTimes {
        timeWorkTotal
        timeDriving
        timePaidRest
        timeAvailability
        timeOtherWork
        timePause
      }
      drivenCoordinates {
        vehicleVin
        coordinates {
          lat
          lng
          timestamp
        }
      }
      startLocation {
        id
        totalKmDriven
        totalFuelUsed
        details {
          id
          description
        }
      }
      endLocation {
        id
        totalKmDriven
        totalFuelUsed
        details {
          id
          description
        }
      }
    }
  }
`)

export const GRAPH_WORK_PERIOD = graphql(`
  query GraphWorkPeriod($id: ID!) {
    workPeriod(id: $id) {
      id
      datetimeStart
      datetimeEnd
      approvedByUser
      approvedByManager
      userComment
      managerComment
      absenceHourTransaction {
        id
      }
      user {
        id
        fullName
      }
      activities {
        id
        activityType
        datetimeStart
        datetimeEnd
        excludeFromSalaryCalculation
        excludeBefore
        excludeAfter
        duration
      }
      timeEntries {
        id
        datetimeStart
        datetimeEnd
        totalWorkTime
        comment
      }
      salaryActivities {
        id
        activityType
        datetimeStart
        datetimeEnd
        excludeFromSalaryCalculation
        excludeBefore
        excludeAfter
        duration
      }
      groupedActivities {
        salaryId
        salaryName

        vehicleVin
        regNr
        startTime
        endTime
      }
    }
  }
`)

export const CLOSEST_CALENDAR_ITEMS = graphql(`
  query ClosestCalendarItems($workPeriodId: ID!) {
    closestCalendarItemsToWorkPeriod(workPeriod: $workPeriodId) {
      id
      title
      start
      end
      workPeriods {
        edges {
          node {
            id
            datetimeStart
            datetimeEnd
          }
        }
      }
    }
  }
`)

export const ALL_SALARY_GROUPS = graphql(`
  query AllSalaryGroups {
    allSalaryGroups {
      edges {
        node {
          id
          name
          users {
            edges {
              node {
                id
                fullName
              }
            }
          }
          responsibleUsers {
            edges {
              node {
                id
                fullName
              }
            }
          }
        }
      }
    }
  }
`)
